import React, { useState } from "react";
import "./login.css";
import "./common-view.css";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { BACKEND_BASE_URL } from "../config/appUrls";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();

  const onSubmit = async e => {
    e.preventDefault();
    setErr("");

    try {
      const base = BACKEND_BASE_URL;
      const res = await fetch(`${base}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password })
      });

      const json = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(json?.error || "Login failed");

      localStorage.setItem("mercadito_token", json.token);

      if (json.must_change_password) {
        window.location.href = "/change-password";
      } else {
        window.location.href = "/dashboard";
      }
    } catch (e2) {
      setErr(e2.message);
    }
  };

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={onSubmit}>
        <h1 className="login-title">{t('login.title')}</h1>
        <p className="login-subtitle">
          {t('login.subTitle')}
        </p>

        {err && <div className="login-error">❌ {err}</div>}

        <label className="login-label">{t('login.username')}</label>
        <input
          className="login-input"
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoComplete="username"
        />

        <label className="login-label">{t('login.password')}</label>
        <div className="password-wrapper">
          <input
            className="login-input"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={e => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <button
            type="button"
            className="toggle-password"
            onClick={() => setShowPassword(v => !v)}
            title={showPassword ? t('login.hidePassword', 'Hide password') : t('login.showPassword', 'Show password')}
          >
            {showPassword ? (
              /* Open Eye: Password is plain text */
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="20" height="20">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            ) : (
              /* Slashed/Closed Eye: Password is masked/hidden */
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="20" height="20">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
              </svg>
            )}
          </button>
        </div>

        <div className="login-actions">
          <button className="btn-login-primary" type="submit">
            {t('login.loginButton', 'Log In')}
          </button>

          <a className="btn-login-cancel" href="/">
            <span className="btn-back-icon">←</span>
            <span>{t('login.backHome', 'Back to Home')}</span>
          </a>
        </div>
      </form>
    </div>
  );
};

export default Login;